import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, Button, FormField, Select, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelFlight from '../../../../../components/extras/SidePanelFlight';
import TableFlights from '../../../../../components/tables/tableFlights';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemFlight, pilotTypes } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

export const MembersEDVFlightLogsPage = () => {
    //const storeAdmin = useStoreAdmin();
    const [stage, setStage] = useState("A")


    const { navigate } = useRouter();
    const { data, parameters, menu, idUser } = useGlobalState();
    const [flights, setFlights] = useState<ItemFlight[]>([]);
    const [flight, setFlight] = useState<ItemFlight>();

    const handleFlightsSearch = async () => {
        try {
            setLoading(true)
            setFlights([]);
            let body: any = {
                startDate: parameters.startDate,
                endDate: parameters.endDate,
                pilotType: parameters.pilotType ? parameters.pilotType : '',
                idUser: idUser,
                orderBy: "departureDate",
                order: "desc",
            }
            if (parameters.groupTypeMasterCode && parameters.groupTypeMasterCode.value != '') {
                body = { ...body, groupTypeMasterCode: parameters.groupTypeMasterCode.value }
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/global/flights/list',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            addNotificationStatus(data, setData);
            if (data.code == 0) {
                setFlights(data.flights);
                setFlight(undefined)
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            splitPanel={
                <SidePanelFlight flight={flight} />
            }
            splitPanelOpen={!!flight}
            onSplitPanelToggle={({ detail }) => !detail.open ? setFlight(undefined) : null}
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Bitácora de vuelos</Header>
                    <SpaceBetween direction="horizontal" size="xs">
                        <Box textAlign='left'>
                            <SpaceBetween direction="horizontal" size="xs">
                                <FormField label="Rango de fechas">
                                    <DRPicker
                                        start={parameters.startDate || ''}
                                        end={parameters.endDate || ''}
                                        onConfirm={(start: string, end: string) => {
                                            setParameters({ ...parameters, startDate: start, endDate: end });

                                        }}
                                    />
                                </FormField>
                                <FormField label="Tipo de vuelo">
                                    <Select
                                        selectedOption={parameters.groupTypeMasterCode || { value: '', label: 'Todos' }}
                                        onChange={(e) => {
                                            setParameters({ ...parameters, groupTypeMasterCode: e.detail.selectedOption });
                                        }}
                                        options={[
                                            { value: '', label: 'Todos' },
                                            { value: 'GLIDER', label: 'Planeador' },
                                            { value: 'PLANE', label: 'Avión' },
                                        ]}
                                    />
                                </FormField>
                                <FormField label="Al mando">
                                    <Select
                                        selectedOption={pilotTypes.find(pt => pt.value === parameters.pilotType) || { value: 'PILOT', label: 'Piloto' }}
                                        onChange={(e) => {
                                            setParameters({ ...parameters, pilotType: e.detail.selectedOption });
                                        }}
                                        options={pilotTypes}
                                    />
                                </FormField>
                            </SpaceBetween>
                        </Box>
                        <Box textAlign='right'>
                            <FormField label="&nbsp;">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button style={{ root: btnIconForm }} onClick={() => handleFlightsSearch()} disabled={parameters.startDate === undefined || parameters.endDate === undefined || parameters.startDate === "" || parameters.endDate === ""}><Icon path={mdiMagnify} size={1} /></Button>
                                </SpaceBetween>
                            </FormField>
                        </Box>
                    </SpaceBetween>
                    <TableFlights flights={flights} onSelect={(fl: ItemFlight) => setFlight(fl)}
                        excel footer

                    />


                </SpaceBetween>
            }
        />
    )
};

